import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';

// 竞品下载 excel 列配置
const columns = [
  {
    title: '游戏名称',
    key: 'name',
  },
  {
    title: '游戏类型',
    key: 'type',
  },
  {
    title: '游戏ID',
    key: 'app_id',
  },
  {
    title: '游戏品类 Main Genre',
    key: 'genre',
  },
  {
    title: '游戏品类 Sub Genre',
    key: 'sub_genre_first',
  },
  {
    title: '游戏品类 Sub Genre',
    key: 'sub_genre_second',
  },
  {
    title: '发行商',
    key: 'publisher',
  },
  {
    title: '开发商',
    key: 'developer',
  },
  {
    title: '上线时间',
    key: 'time',
  },
];

// 使用传入的 fileName 文件名
function getDownloadParams(params: Record<string, any>) {
  return { $$fileName: params.fileName };
}

export default (params: Record<string, any>) => {
  return {
    ...commonSetting,
    // 使用传输的竟态文件下载，不调用接口
    isUsingStaticDownload: true,
    sheetName: ['Sheet1'],
    Sheet1: columns,
    ...getDownloadParams(params),
  };
};
